// 辅助函数：将十六进制颜色转换为 RGB
const hexToRgb = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
};
// 辅助函数：将 RGB 转换为十六进制颜色
const rgbToHex = (r, g, b) => {
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
};
// 辅助函数：调整颜色亮度
const adjustBrightness = (hex, factor) => {
  const rgb = hexToRgb(hex);
  const newRgb = rgb.map((val) =>
    Math.max(0, Math.min(255, Math.round(val + (255 - val) * factor)))
  );
  return rgbToHex(...newRgb);
};
// 设置主题颜色
export const setThemeColor = (e) => {
  let colors = {
    primary: e, // 假设变量 primary 的值是 "#f6f6f6"
  };
  // 生成浅色变体
  for (let i = 1; i <= 9; i++) {
    const factor = i * 0.1;
    colors[`primary-light-${i}`] = adjustBrightness(e, factor);
  }
  // 生成深色变体
  colors["primary-dark-2"] = adjustBrightness(e, -0.2);

  //根据上述 生成primary 同理可生成成功失败警告信息等颜色

  const el = document.documentElement;
  Object.entries(colors).forEach(([key, value]) => {
    el.style.setProperty(`--el-color-${key}`, value);
  });
};
